import { render } from "./IconBreak.vue?vue&type=template&id=3b1917e0"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconBreak.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b1917e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b1917e0', __exports__)) {
    api.reload('3b1917e0', __exports__)
  }
  
  module.hot.accept("./IconBreak.vue?vue&type=template&id=3b1917e0", () => {
    api.rerender('3b1917e0', render)
  })

}


export default __exports__